var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.05 39.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "_450_camera_image_picture_photo",
    "data-name": "450, camera, image, picture, photo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m50.21,39.72H4.84c-2.62,0-4.84-2.22-4.84-4.84V9.48c0-2.62,2.12-4.84,4.84-4.84h45.37c2.62,0,4.84,2.22,4.84,4.84v25.31c-.1,2.72-2.22,4.94-4.84,4.94ZM4.84,6.96c-1.31,0-2.42,1.11-2.42,2.52v25.31c0,1.41,1.11,2.52,2.42,2.52h45.37c1.31,0,2.42-1.11,2.42-2.52V9.48c0-1.41-1.11-2.52-2.42-2.52H4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m24.6,16.33H1.21c-.6,0-1.21-.5-1.21-1.21v-5.85c0-2.62,2.12-4.74,4.84-4.74h19.76c.6,0,1.21.5,1.21,1.21v9.38c0,.71-.6,1.21-1.21,1.21ZM2.42,14.01h20.97v-6.96H4.94c-1.41,0-2.52,1.11-2.52,2.42v4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m39.82,30.35c-4.54,0-8.17-3.63-8.17-8.17s3.63-8.17,8.17-8.17,8.17,3.63,8.17,8.17-3.73,8.17-8.17,8.17Zm0-14.01c-3.23,0-5.85,2.62-5.85,5.85s2.62,5.85,5.85,5.85,5.85-2.62,5.85-5.85-2.62-5.85-5.85-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m39.82,33.88c-6.45,0-11.7-5.24-11.7-11.7s5.24-11.7,11.7-11.7c3.13,0,6.05,1.21,8.27,3.43,2.22,2.22,3.43,5.14,3.43,8.27s-1.21,6.05-3.43,8.27c-2.32,2.22-5.24,3.43-8.27,3.43Zm0-21.07c-5.14,0-9.38,4.23-9.38,9.38s4.23,9.28,9.38,9.28,9.38-4.13,9.38-9.28c-.1-5.14-4.23-9.38-9.38-9.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m12.91,6.96h-4.64c-.6,0-1.21-.5-1.21-1.21v-3.53c0-.61.5-1.21,1.21-1.21h4.64c.6,0,1.21.5,1.21,1.21v3.53c0,.71-.5,1.21-1.21,1.21Zm-3.53-2.32h2.32v-1.21h-2.32v1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m46.78,6.96h-8.17c-.6,0-1.21-.5-1.21-1.21V1.21c0-.6.5-1.21,1.21-1.21h8.17c.6,0,1.21.5,1.21,1.21v4.64c0,.6-.5,1.11-1.21,1.11Zm-6.96-2.32h5.85v-2.32h-5.85v2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m9.07,33.88c-1.01,0-2.02-.4-2.82-1.11-.71-.71-1.21-1.71-1.11-2.82,0-1.01.4-2.02,1.21-2.72q.2-.2,1.21-.61c1.41-.6,5.14-2.12,6.05-2.72.5-.3,1.01-.2,1.41.2s.4.91.2,1.41c-.5.91-2.12,4.64-2.72,6.05q-.4,1.01-.6,1.21c-.81.71-1.81,1.11-2.82,1.11Zm-1.31-4.94c-.2.3-.3.6-.3,1.01s.2.81.5,1.11c.3.3.71.5,1.11.5s.71-.1,1.01-.3c.1-.1.1-.3.2-.6.5-1.11,1.01-2.32,1.41-3.33-1.01.4-2.22.91-3.33,1.41-.2,0-.5.1-.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m39.93,26.32c-.2,0-.4-.1-.6-.2l-2.22-1.21c-.4-.2-.6-.6-.6-1.01v-2.72c0-.4.2-.81.6-1.01l2.32-1.31c.4-.2.81-.2,1.21,0l2.32,1.31c.4.2.6.6.6,1.01v2.72c0,.4-.2.81-.6,1.01l-2.32,1.31c-.3.1-.5.1-.71.1Zm-1.11-3.13l1.11.71,1.11-.61v-1.31l-1.11-.6-1.11.71v1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m15.22,11.7H1.51c-.6,0-1.21-.5-1.21-1.21,0-.61.5-1.21,1.21-1.21h13.81c.6,0,1.21.5,1.21,1.21-.1.71-.6,1.21-1.31,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m19.96,11.7h-1.21c-.6,0-1.21-.5-1.21-1.21,0-.61.5-1.21,1.21-1.21h1.21c.6,0,1.21.5,1.21,1.21-.1.71-.6,1.21-1.21,1.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f43806f7772cc1d510ef264c05be31c0.svg";
export { ForwardRef as ReactComponent };